/**
 * API Debug utility for development
 * Logs API requests and responses when REACT_APP_DEBUG is enabled
 */

const isDebugEnabled = process.env.REACT_APP_DEBUG === 'true';

export const apiDebug = {
  /**
   * Log API request details
   * @param {string} method - HTTP method
   * @param {string} url - Request URL
   * @param {Object} data - Request data (optional)
   */
  logRequest: (method, url, data = null) => {
    if (!isDebugEnabled) return;
    
    console.group(`🌐 API Request: ${method} ${url}`);
    console.log('Method:', method);
    console.log('URL:', url);
    if (data) {
      console.log('Data:', data);
    }
    console.groupEnd();
  },

  /**
   * Log API response details
   * @param {string} method - HTTP method
   * @param {string} url - Request URL
   * @param {Object} response - Response data
   * @param {number} status - HTTP status code
   */
  logResponse: (method, url, response, status) => {
    if (!isDebugEnabled) return;
    
    const isSuccess = status >= 200 && status < 300;
    const icon = isSuccess ? '✅' : '❌';
    
    console.group(`${icon} API Response: ${method} ${url} (${status})`);
    console.log('Status:', status);
    console.log('Response:', response);
    console.groupEnd();
  },

  /**
   * Log API error details
   * @param {string} method - HTTP method
   * @param {string} url - Request URL
   * @param {Error} error - Error object
   */
  logError: (method, url, error) => {
    if (!isDebugEnabled) return;
    
    console.group(`🚨 API Error: ${method} ${url}`);
    console.log('Error:', error);
    console.log('Message:', error.message);
    console.log('Stack:', error.stack);
    console.groupEnd();
  },

  /**
   * Check if debug mode is enabled
   * @returns {boolean} True if debug mode is enabled
   */
  isEnabled: () => isDebugEnabled
}; 